import PropTypes from "prop-types";
import { Button } from "@mui/material";

const LivisButton = (props: any) => {
  const {
    type,
    label,
    livis_class,
    livis_click_function,
    disabled,
    livis_id,
    icon,
    icon_width,
    livis_icon,
    forceAlignButton = false
  } = props;

  return (
    <>
      <Button
        type={type}
        className={forceAlignButton && disabled ? "livis-published-disabled-button "+livis_class : disabled && label != "Published" ? "livis-disabled-btn "+livis_class : disabled && label == "Published" ? "livis-published-disabled-button "+livis_class : livis_class}
        onClick={livis_click_function}
        disabled={disabled}
        id={livis_id}
      >
        {
          livis_icon ? (
            livis_icon
          ):
          (
            icon && <img
              src={icon}
              alt=""
              width={icon_width ? icon_width : 20}
              height={icon_width ? icon_width : 20}
              className="livis-button-icon"
            />
          )
        }
        {label}
      </Button>
    </>
  );
};

LivisButton.propTypes = {
  type: PropTypes.any,
  label: PropTypes.string,
  livis_class: PropTypes.string,
  livis_click_function: PropTypes.func,
  disabled: PropTypes.bool,
  livis_id: PropTypes.string,
  icon: PropTypes.string,
  icon_width: PropTypes.number,
  livis_icon: PropTypes.node,
  forceAlignButton: PropTypes.bool
};

LivisButton.defaultProps = {
  type: "button",
  label: "Submit",
  livis_class: "livis-primary-btn",
  disabled: false,
  livis_id: "livis-button-id",
  icon: "",
  icon_width: 20,
  livis_icon: null,
  forceAlignButton: false
};

export default LivisButton;
